import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  SubGroup,
  SubscriptionOrganization,
} from "src/app/shared/interfaces/orgadmin/course-organization";

export const coursePrefix = "[Course Teachers List]";

const courseTeachersListActions = {
  reset: `${coursePrefix} Reset`,
  request: `${coursePrefix} Load`,
  requestDelete: `${coursePrefix} Delete`,
  requestSuccess: `${coursePrefix} Load success`,
  requestFail: `${coursePrefix} Load fail`,
  requestUpdate: `${coursePrefix} Update`,
};

export const courseTeachersListLoad = createAction(
  courseTeachersListActions.request,
  props<{ organizationId: string; subId: string; search?: string }>(),
);

export const courseTeachersListLoadSuccess = createAction(
  courseTeachersListActions.requestSuccess,
  props<{ teachersList: SubscriptionOrganization; subId: string }>(),
);

export const courseTeachersListReset = createAction(
  courseTeachersListActions.reset,
);

export const courseTeachersListLoadFail = createAction(
  courseTeachersListActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);

export const courseTeachersListUpdate = createAction(
  courseTeachersListActions.requestUpdate,
  props<{ teachers: SubGroup }>(),
);

export const courseTeachersDelete = createAction(
  courseTeachersListActions.requestDelete,
  props<{ teamId: string }>(),
);
